import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-addcategory',
  templateUrl: './addcategory.component.html',
  styleUrls: ['./addcategory.component.css']
})
export class AddcategoryComponent implements OnInit {

  category: Productcategory;


  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(private productServices: ProductService, private router: Router) {
    this.category = new Productcategory;
    this.category.storeId = 1;
  }

  ngOnInit() {

    this.dropdownList = [
      { item_id: 1, item_text: 'Canada' },
      { item_id: 2, item_text: 'US' }
    ];
    this.selectedItems = [
      { item_id: 1, item_text: 'Canada' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  AddProductCategory(form: NgForm) {
    console.log(form.value.storeId);
    var tempstoreid = [];
    if (form.value.storeId.length > 0) {
      form.value.store = [];
      for (var i = 0; i < form.value.storeId.length; i++) {
        if (form.value.storeId[i].item_id == "1") {
          form.value.store[i] = "Canada";
          tempstoreid[i] = "1"
        }
        else if (form.value.storeId[i].item_id == "2") {
          form.value.store[i] = "US";
          tempstoreid[i] = "2"
        }
        else { }
      }
      form.value.store = form.value.store.join();
      //form.value.storeId = form.value.storeId.join();
      form.value.storeId = tempstoreid.join();
      console.log(form.value);

      this.productServices.addProductCategory(form.value)
        .subscribe((data: any) => {
          if (data == true) {
            //alert("saved");
            this.router.navigate(['/categorylist']);
          }
          else {
            alert("category already exist");
          }
        });
    }
    else {
      alert("please select location");
    }

  }

}
